export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hallo i18n !!"])},
  "nav": {
    "languages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprachen"])}
  }
}